import {
  kBiVizStyleDefaults,
  kBiVizStyleOptionNames,
} from '@euler/model/bi/viz';
import { memo } from 'react';
import { BiChip } from '../../../../components/ui/BiChip';
import { StyleGroup } from '../StyleGroup';
import { StyleRow } from '../StyleRow';
import { biWithStyleOption } from '../functions/biStyleEdit';
import { BiStyleOptionProps } from '../functions/biStyleOptionProps';

/**
 * An on / off option: grid lines, data labels. `fallback` is its look when
 * unset, where the chart type has its own (a funnel shows its labels).
 */
export const FlagOption = memo(
  ({
    option,
    style,
    onChange,
    fallback = kBiVizStyleDefaults[option],
  }: BiStyleOptionProps & {
    option: 'gridLines' | 'dataLabels';
    fallback?: boolean;
  }) => {
    const on = style?.[option] ?? fallback;
    const set = (value: boolean) =>
      onChange(biWithStyleOption(style, option, value));
    return (
      <StyleGroup
        title={kBiVizStyleOptionNames[option]}
        onReset={
          style?.[option] !== undefined
            ? () => onChange(biWithStyleOption(style, option, undefined))
            : null
        }
      >
        <StyleRow label="显示">
          <BiChip label="显示" selected={on} onPress={() => set(true)} />
          <BiChip label="隐藏" selected={!on} onPress={() => set(false)} />
        </StyleRow>
      </StyleGroup>
    );
  },
);
